// Central data source for Be Easy Cars

export const BRAND = {
  name: "Be Easy Cars",
  tagline: "Easy Deals • Smooth Drives",
  phone: "9820692779",
  phoneDisplay: "+91 98206 92779",
  email: "beeasycars@gmail.com",
  address: "Thane West, Maharashtra, India",
  hours: "Mon–Sat: 10:00 AM – 7:00 PM",
  whatsappUrl: "https://wa.me/919820692779?text=Hi%20Be%20Easy%20Cars%2C%20I%27m%20interested%20in%20T-Permit%20vehicles",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.4396!2d72.9707!3d19.2183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sThane%20West!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const VEHICLES = [
  {
    slug: "hyundai-aura-prime",
    name: "Hyundai Aura Prime",
    tagline: "Value-Driven City Sedan",
    fuel: "Petrol",
    seats: 5,
    mileage: "20 km/l",
    engine: "1.2L Kappa",
    priceFrom: "₹ 7,93,100",
    idealFor: ["City Taxi", "Airport Duty", "Fleet Business"],
    highlights: [
      "Reliable Hyundai build quality",
      "Spacious sedan cabin",
      "Low maintenance cost",
      "Strong resale value",
    ],
    color: "#B8C5D1",
    image: "/aura1.jpg",
    accent: "from-blue-400/20 to-slate-800/40",
  },
  {
    slug: "hyundai-aura-corporate",
    name: "Hyundai Aura Corporate",
    tagline: "Corporate-Ready Sedan",
    fuel: "Petrol",
    seats: 5,
    mileage: "20 km/l",
    engine: "1.2L Kappa",
    priceFrom: "₹ 8,89,100",
    idealFor: ["Corporate Fleet", "Airport Taxi", "City Taxi"],
    highlights: [
      "Premium corporate feel",
      "Comfortable ride quality",
      "Feature-rich interior",
      "Smooth drivability",
    ],
    color: "#A0B0C0",
    image: "/aura2.jpg",
    accent: "from-blue-500/20 to-slate-800/40",
  },
  {
    slug: "hyundai-aura-s",
    name: "Hyundai Aura S",
    tagline: "The Efficient City Warrior",
    fuel: "Petrol",
    seats: 5,
    mileage: "20 km/l",
    engine: "1.2L Kappa",
    priceFrom: "₹ 8,93,100",
    idealFor: ["Airport Taxi", "City Taxi", "Fleet Business"],
    highlights: [
      "Excellent fuel efficiency",
      "Spacious cabin with boot",
      "Reliable long-term performance",
      "Low running cost per km",
    ],
    color: "#B8C5D1",
    image: "/aura3.jpg",
    accent: "from-blue-500/20 to-slate-800/40",
  },
  {
    slug: "hyundai-aura-sx",
    name: "Hyundai Aura SX",
    tagline: "Feature-Packed Sedan",
    fuel: "Petrol",
    seats: 5,
    mileage: "20 km/l",
    engine: "1.2L Kappa",
    priceFrom: "₹ 9,65,100",
    idealFor: ["Airport Premium", "Corporate Fleet", "City Taxi"],
    highlights: [
      "Top-end features & styling",
      "Premium interior touches",
      "Advanced infotainment",
      "Superior comfort & safety",
    ],
    color: "#C0D0E0",
    image: "/aura4.jpg",
    accent: "from-blue-600/20 to-slate-800/40",
  },
  {
    slug: "maruti-wagonr-tour-h3",
    name: "Maruti WagonR Tour H3",
    tagline: "The Budget Workhorse",
    fuel: "Petrol",
    seats: 5,
    mileage: "25 km/l",
    engine: "1.0L K10C",
    priceFrom: "₹ 6,67,853",
    idealFor: ["City Taxi", "Fleet Business", "E-commerce Delivery"],
    highlights: [
      "Most affordable commercial hatch",
      "Tallboy design for easy entry-exit",
      "Lowest cost of ownership",
      "Wide service network",
    ],
    color: "#E8B84B",
    image: "/wagonr1.jpg",
    accent: "from-yellow-400/20 to-slate-800/40",
  },
  {
    slug: "maruti-wagonr-vxi",
    name: "Maruti WagonR VXi",
    tagline: "The Versatile Workhorse",
    fuel: "Petrol",
    seats: 5,
    mileage: "25 km/l",
    engine: "1.2L K-Series",
    priceFrom: "₹ 7,31,280",
    idealFor: ["City Taxi", "Fleet Business", "Tourist Vehicle"],
    highlights: [
      "Powerful 1.2L engine",
      "Spacious cabin & large boot",
      "Smooth drive experience",
      "Low maintenance cost",
    ],
    color: "#E8B84B",
    image: "/wagonr2.jpg",
    accent: "from-yellow-500/20 to-slate-800/40",
  },
  {
    slug: "toyota-innova-crysta-gx-7str",
    name: "Toyota Innova Crysta GX 7STR",
    tagline: "The Trusted People Mover",
    fuel: "Diesel",
    seats: 7,
    mileage: "16 km/l",
    engine: "2.4L Diesel",
    priceFrom: "₹ 21,16,271",
    idealFor: ["Tourist Business", "Airport Group Transfer", "Fleet Operations"],
    highlights: [
      "Unmatched reliability & trust",
      "Spacious 7-seater comfort",
      "Powerful diesel performance",
      "Industry-leading resale value",
    ],
    color: "#708090",
    image: "/innova1.jpg",
    accent: "from-slate-400/20 to-slate-800/40",
  },
  {
    slug: "toyota-innova-crysta-gx-plus-7str",
    name: "Toyota Innova Crysta GX+ 7STR",
    tagline: "Premium MPV Experience",
    fuel: "Diesel",
    seats: 7,
    mileage: "16 km/l",
    engine: "2.4L Diesel",
    priceFrom: "₹ 22,91,180",
    idealFor: ["Airport Premium", "Tourist Business", "Corporate Fleet"],
    highlights: [
      "Enhanced safety features",
      "Premium interior upgrades",
      "Smooth automatic transmission",
      "Superior ride comfort",
    ],
    color: "#6A7A8A",
    image: "/innova2.jpg",
    accent: "from-slate-500/20 to-slate-800/40",
  },
  {
    slug: "toyota-innova-crysta-vx-7str",
    name: "Toyota Innova Crysta VX 7STR",
    tagline: "Executive-Class MPV",
    fuel: "Diesel",
    seats: 7,
    mileage: "15 km/l",
    engine: "2.4L Diesel",
    priceFrom: "₹ 26,51,503",
    idealFor: ["VIP Fleet", "Airport Premium", "Tourist Business"],
    highlights: [
      "Executive-level comfort",
      "Advanced infotainment system",
      "Captain seat option",
      "Top-tier safety package",
    ],
    color: "#5A6A7A",
    image: "/innova3.jpg",
    accent: "from-slate-600/20 to-slate-800/40",
  },
  {
    slug: "toyota-innova-crysta-zx-7str",
    name: "Toyota Innova Crysta ZX 7STR",
    tagline: "The Flagship MPV",
    fuel: "Diesel",
    seats: 7,
    mileage: "15 km/l",
    engine: "2.4L Diesel",
    priceFrom: "₹ 28,16,894",
    idealFor: ["VIP Fleet", "Airport Luxury", "Premium Tourist"],
    highlights: [
      "Top-of-the-line features",
      "Premium leather interiors",
      "Full safety suite",
      "Unmatched road presence",
    ],
    color: "#4A5A6A",
    image: "/innova4.jpg",
    accent: "from-slate-700/20 to-slate-800/40",
  },
  {
    slug: "maruti-dzire-tour-s",
    name: "Maruti Dzire Tour S",
    tagline: "India's Commercial Favourite",
    fuel: "Petrol",
    seats: 5,
    mileage: "25 km/l",
    engine: "1.2L VVT",
    priceFrom: "₹ 8,18,022",
    idealFor: ["Airport Duty", "Uber / Ola", "Tourist Sedan"],
    highlights: [
      "Highest resale value in class",
      "Proven for commercial duty cycles",
      "Comfortable rear seating",
      "Widely available service network",
    ],
    color: "#EDEDED",
    image: "/dzire1.jpg",
    accent: "from-red-500/20 to-slate-800/40",
  },
  {
    slug: "toyota-rumion-s-cng",
    name: "Toyota Rumion S CNG",
    tagline: "Reliable 7-Seater MPV",
    fuel: "CNG + Petrol",
    seats: 7,
    mileage: "26 km/kg",
    engine: "1.5L K-Series",
    priceFrom: "₹ 12,77,984",
    idealFor: ["Tourist Business", "Airport Transfers", "Family Fleet"],
    highlights: [
      "Trusted Toyota reliability",
      "Spacious 7-seater cabin",
      "Excellent CNG fuel efficiency",
      "Low running cost",
    ],
    color: "#A8B4C8",
    image: "/rumion1.jpg",
    accent: "from-indigo-500/20 to-slate-800/40",
  },
  {
    slug: "maruti-ertiga-vxl",
    name: "Maruti Ertiga VXL",
    tagline: "The Family & Tourist MPV",
    fuel: "Petrol",
    seats: 7,
    mileage: "20 km/l",
    engine: "1.5L K-Series",
    priceFrom: "₹ 12,16,528",
    idealFor: ["Tourist Business", "Airport Transfers", "Family Fleet"],
    highlights: [
      "True 7-seater MPV",
      "Ideal for outstation tours",
      "Excellent cabin space",
      "Strong commercial demand",
    ],
    color: "#B8C5D1",
    image: "/ertiga1.jpg",
    accent: "from-blue-500/20 to-slate-800/40",
  },
  {
    slug: "maruti-ertiga-zxi",
    name: "Maruti Ertiga ZXI",
    tagline: "Premium 7-Seater MPV",
    fuel: "Petrol",
    seats: 7,
    mileage: "20 km/l",
    engine: "1.5L K-Series",
    priceFrom: "₹ 13,22,699",
    idealFor: ["Premium Tourist", "Airport Transfers", "Corporate Fleet"],
    highlights: [
      "Top-end features & safety",
      "Premium interior touches",
      "Spacious & comfortable ride",
      "High resale value",
    ],
    color: "#C0D0E0",
    image: "/ertiga2.jpg",
    accent: "from-blue-600/20 to-slate-800/40",
  },
];

export const SERVICES = [
  {
    icon: "Car",
    title: "T-Permit Vehicle Sales",
    desc: "Brand-new yellow number plate commercial vehicles from Hyundai, Maruti Suzuki and Tata Motors.",
  },
  {
    icon: "Banknote",
    title: "Vehicle Finance Assistance",
    desc: "Loan consultation with leading banks & NBFCs. EMI planning, documentation support, quick approvals.",
  },
  {
    icon: "FileCheck2",
    title: "T-Permit & RTO Registration",
    desc: "End-to-end commercial registration, permit paperwork, and RTO liaison from day one.",
  },
  {
    icon: "ShieldCheck",
    title: "Commercial Insurance",
    desc: "Guidance for the right commercial vehicle insurance policy and hassle-free renewals.",
  },
  {
    icon: "Plane",
    title: "Airport Attachment Support",
    desc: "Onboarding guidance with airport & corporate fleet operators (subject to operator eligibility).",
  },
  {
    icon: "Users",
    title: "Fleet & Business Consultation",
    desc: "Strategy for scaling from 1 to a full fleet — vehicle mix, driver onboarding, unit economics.",
  },
];

export const REASONS = [
  "One-stop commercial vehicle solution",
  "Transparent & reliable pricing",
  "End-to-end customer support",
  "Fast documentation & delivery",
  "Trusted finance partner network",
  "Dedicated after-sales assistance",
];

export const FAQS = [
  {
    q: "What is a T-Permit vehicle?",
    a: "A T-Permit (Tourist Permit) vehicle is a commercially registered car with a yellow number plate, legally allowed to carry passengers for hire and reward in Maharashtra.",
  },
  {
    q: "Can I finance my commercial vehicle through Be Easy Cars?",
    a: "Yes. We work with leading banks and NBFCs to help you secure vehicle finance. Final approval, interest rate and tenure depend on your eligibility profile.",
  },
  {
    q: "Do you help with registration and permits?",
    a: "Yes — we handle end-to-end documentation, T-Permit registration and RTO coordination so you can focus on your business.",
  },
  {
    q: "Do you assist with commercial insurance?",
    a: "Yes. We guide you to the right commercial vehicle insurance product and support renewals every year.",
  },
  {
    q: "Do you help with airport taxi attachment?",
    a: "We provide guidance and support for eligible airport and corporate fleet attachment opportunities. Availability depends on the operator's requirements and market conditions.",
  },
  {
    q: "Which cars do you sell?",
    a: "Hyundai Aura (Prime, Corporate, S, SX), Maruti WagonR (Tour H3, VXi) and Toyota Innova Crysta (GX, GX+, VX, ZX) — plus other eligible commercial models on request.",
  },
  {
    q: "How long does the purchase process take?",
    a: "Timelines depend on vehicle availability, finance approval and RTO scheduling. In most cases we complete delivery within a few working days after documentation is complete.",
  },
  {
    q: "Do you sell used T-Permit vehicles?",
    a: "Our primary focus is brand-new commercial vehicles. Please contact us to discuss any specific requirement.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ramesh K.",
    role: "Fleet Owner",
    location: "Thane",
    rating: 5,
    quote:
      "From vehicle selection to yellow plate registration — Be Easy Cars handled everything. Delivery was on time and the finance paperwork was smooth.",
  },
  {
    name: "Sunil P.",
    role: "Airport Taxi Operator",
    location: "Mumbai",
    rating: 5,
    quote:
      "Finance process was easy and completely transparent. Their team explained every document and my EMI in detail. Highly recommended.",
  },
  {
    name: "Ajay S.",
    role: "First-time Taxi Owner",
    location: "Kalyan",
    rating: 5,
    quote:
      "Professional staff and honest advice. They didn't oversell — they matched me with the right vehicle for my route. Excellent after-sales too.",
  },
  {
    name: "Vikram D.",
    role: "Tourist Vehicle Operator",
    location: "Navi Mumbai",
    rating: 5,
    quote:
      "Bought my Ertiga Tour M through them. Guidance on permit and insurance saved me weeks of running around. Truly one-stop.",
  },
];

export const GALLERY = [
  { url: "/img1.jpg", label: "Vehicle Delivery" },
  { url: "/img2.jpg", label: "Fleet Line-up" },
  { url: "/img3.jpg", label: "Highway Duty" },
  { url: "/img4.jpg", label: "Ertiga MPV Handover" },
  { url: "/img6.jpg", label: "Night Drive" },
  { url: "/img7.jpg", label: "Sedan Ready" },
  { url: "/img8.jpg", label: "Registration Support" },
  { url: "/img9.jpg", label: "Vehicle Delivery" },
  { url: "/img10.jpg", label: "Fleet Line-up" },
  { url: "/img11.jpg", label: "Highway Duty" },
  { url: "/img12.jpg", label: "Ertiga MPV Handover" },
  { url: "/img13.jpg", label: "EV Handover" },
  { url: "/img20.jpg", label: "Highway Duty" },
  { url: "/img23.jpg", label: "Night Drive" },
];

export const STATS = [
  { value: "500+", label: "T-Permit Vehicles Delivered" },
  { value: "12+", label: "Finance Partner Banks" },
  { value: "48 hr", label: "Avg. Paperwork Turnaround" },
  { value: "100%", label: "RTO Support Coverage" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/vehicles", label: "Vehicles" },
  { to: "/services", label: "Services" },
  { to: "/finance", label: "Finance" },
  { to: "/airport-attachment", label: "Airport" },
  { to: "/business", label: "Business" },
  { to: "/blog", label: "Blog" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
